
"use strict";

/**
 * Payment methods, same as PHP class
 */
export const PaymentMethod = Object.freeze({
  NONE:           0,  /* Ungültig */
  FREE_OF_CHARGE: 1,  /* Keine */
  INVOICE:        2,  /* Rechnung */
  DIRECT_DEBIT:   3,  /* SEPA Lastschrift */
});



// WEBPACK FOOTER //
// ./assets/scripts/common/enums.js